import React, { useState } from "react";
import { BiTrash } from "react-icons/bi";
import { FiEdit3 } from "react-icons/fi";

function USerTableRow({ item, user, idx, handleSingleDelete, handleUserEdit }) {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async (_id) => {
    const res = await handleSingleDelete(_id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility && (
        <tr
          key={idx}
          className="bg-white border-b last:border-b-0 dark:bg-gray-900 dark:border-gray-700"
        >
          <th
            scope="row"
            className="px-6 pl-10 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-gray-200"
          >
            {idx < 10 && "0"}
            {idx + 1}
          </th>
          <td className="px-6 py-4 flex flex-col">
            <span className="text-gray-800 dark:text-gray-200 font-semibold">
              {item.email.split("@")[0]}
            </span>
            <span className="uppercase">Role: {item.role}</span>
          </td>
          <td className="px-6 py-4">{item.name}</td>
          <td className="px-6 py-4">
            {item?.createdAt && (
              <span>
                {new Intl.DateTimeFormat(["ban", "id"]).format(
                  new Date(item?.createdAt)
                )}
              </span>
            )}
          </td>
          <td className="px-6 py-4 pl-10">
            {item.status === "active" ? (
              <span className="w-[10px] aspect-square bg-green-600 block rounded-full" />
            ) : (
              <span className="w-[10px] aspect-square bg-red-600 block rounded-full" />
            )}
          </td>
          <td className="px-6 py-4 space-x-1 md:space-x-4 ">
            {item.primary === "false" && (
              <button
                onClick={() => handleUserEdit(item)}
                className={`font-medium text-blue-600`}
              >
                <FiEdit3 className="text-xl" />
              </button>
            )}

            {user.role === "admin" && item.primary === "false" && (
              <button
                onClick={() => handleDelete(item._id)}
                className={`${
                  item.primary === "true" ? "hidden" : ""
                } font-medium text-red-600`}
              >
                <BiTrash className="text-xl" />
              </button>
            )}
          </td>
        </tr>
      )}
    </>
  );
}

export default USerTableRow;
